import { Menu, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { useLayoutContext } from '../../contexts';
import { BellIcon } from '../../icons/BellIcon';
import { OptionsMenuItemWithBadge } from '../../ui/options-menu/option-menu-item-with-badge';

export function NotificationBadge() {
  const { notificationsSections } = useLayoutContext();
  const total =
    notificationsSections?.reduce(
      (acc, item) =>
        acc +
        (item.notificationsItems.reduce(
          (a, i) => a + (i.badgeNumber ?? 0),
          0
        ) ?? 0),
      0
    ) ?? 0;

  return (
    <Menu as="div" className="relative ml-3">
      <Menu.Button className={'flex items-center max-w-xs text-sm'}>
        <span className="sr-only">Abrir Notificações</span>
        <div className="relative">
          <BellIcon />
          {total > 0 && (
            <div className="flex flex-col absolute bottom-3 left-4">
              <span className="animate-ping-slow absolute flex-1 rounded-full size-full bg-red-400 opacity-75 py-0.5 px-1.5"></span>
              <span className="text-xs bg-red-500 text-white rounded-full py-0.5 px-1.5">
                {total}
              </span>
            </div>
          )}
        </div>
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="options-menu-items-container">
          {notificationsSections?.map((section, index) => {
            const items = section.notificationsItems.map((item) => (
              <OptionsMenuItemWithBadge
                badge={item.badgeNumber}
                label={item.label}
                onClick={item.onClick}
                icon={item.icon}
                key={item.label}
              />
            ));

            return <div key={index}>{items}</div>;
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
